import React from 'react';
export function Solution() {
  return <section className="py-20 bg-amber-50" data-id="element-222">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-223">
        <div className="max-w-4xl mx-auto text-center" data-id="element-224">
          <span className="text-amber-600 font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-225">
            The Solution
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-stone-900 mb-6" data-id="element-226">
            Introducing: The Golden Root Ritual
          </h2>
          <p className="text-xl md:text-2xl text-stone-600 italic font-serif mb-12" data-id="element-227">
            The 5-Minute Ancient Protocol to Flush Bloat and Reset Your
            Metabolism.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto" data-id="element-228">
          <div className="relative" data-id="element-229">
            {/* Placeholder for ingredients image or lifestyle shot if we had one, using a nice gradient/pattern block for now or reusing product image in a different context */}
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-xl bg-white p-2" data-id="element-230">
              <img src="https://images.unsplash.com/photo-1615485290382-441e4d049cb5?q=80&w=2080&auto=format&fit=crop" alt="Turmeric and Ginger Roots" className="w-full h-full object-cover rounded-xl" data-id="element-231" />
            </div>
          </div>

          <div className="prose prose-lg prose-stone" data-id="element-232">
            <p className="text-lg leading-relaxed" data-id="element-233">
              I have spent months researching the world’s longest-living
              cultures—women who stay lean, vibrant, and sharp well into their
              80s. They don't use expensive pharmaceuticals or fancy gyms. They
              use <strong data-id="element-234">Biological Hacks</strong> found in nature.
            </p>
            <p className="text-lg leading-relaxed mt-6" data-id="element-235">
              I’ve condensed this wisdom into a high-value, step-by-step digital
              manual designed specifically for the modern woman who doesn’t have
              time to waste.
            </p>
          </div>
        </div>
      </div>
    </section>;
}